module.exports = __webpack_public_path__ + "media/state-press_1200.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/state-press_1200.jpg
// module id = 48
// module chunks = 0